export class WebsocketsService {
  constructor(data) {
    this.data = data;
  }

  async grantPermissionToGroup({ targetGroup, connectionId }) {
    return this.data.grantPermissionToGroup({ targetGroup, connectionId });
  }
}